module.exports = "<atn-list-box\r\n  #list\r\n  name=\"Páginas\"\r\n  outputField=\"title\"\r\n  [service]=\"dataService\"\r\n></atn-list-box>\r\n\r\n<page-form\r\n  *ngIf=\"list.showForm\"\r\n  [id]=\"list.selectedItemId\"\r\n  (onSave)=\"list.hideFormAndReload()\"\r\n  (onDuplicate)=\"list.hideFormAndReload()\"\r\n  (onRemove)=\"list.hideFormAndReload()\"\r\n  (onBack)=\"list.hideForm()\"\r\n></page-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/pages/page-list/page-list.component.html
// module id = ./libs/atenea-cms-brand/src/pages/page-list/page-list.component.html
// module chunks = main